export default __webpack_public_path__ + "static/download-apple-store-0ef9f616eab88a18bcb30f715f226808.svg";